import { metaLine } from '../relationship/startup-side-panel'

/** A startup's line under its name in a list: what it does, then its round, sector and city. */
export function cardLine(
  startup: Parameters<typeof metaLine>[0] & { oneLine: string | null }
): string {
  return [startup.oneLine, metaLine(startup)].filter(Boolean).join(' · ')
}
